import { getInfo, login, logout } from '@/api/user'
import { resetRouter } from '@/router'
import { getToken, removeToken, setToken } from '@/utils/auth'
import Cookies from 'js-cookie'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    uid: null,
    realname: '',
    avatar: '',
    introduction: '',
    roles: [],
    permissions: [],
    routePermissions: []
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_USER: (state, uid) => {
    Cookies.set('uid', uid)
    state.uid = uid
  },
  SET_RREALNAME: (state, realname) => {
    Cookies.set('realname', realname)
    state.realname = realname
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
  },
  SET_ROUTE_PERMISSIONS: (state, routePermissions) => {
    state.routePermissions = routePermissions
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { uname, upwd } = userInfo
    return new Promise((resolve, reject) => {
      login({ uname: uname.trim(), upwd: upwd }).then(response => {
        const { data, uid, realname } = response
        commit('SET_TOKEN', data.token)
        commit('SET_USER', uid)
        commit('SET_RREALNAME', realname)
        setToken(data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const { data } = response
        if (!data) {
          reject('Verification failed, please Login again.')
        }
        const {
          name,
          avatar,
          roles,
          introduction,
          permissions,
          routePermissions
        } = data
        commit('SET_ROLES', roles)
        commit('SET_PERMISSIONS', permissions || [])
        commit('SET_ROUTE_PERMISSIONS', routePermissions || [])
        commit('SET_NAME', name)
        commit('SET_USER', Number(Cookies.get('uid')))
        commit('SET_RREALNAME', Cookies.get('realname'))
        commit('SET_AVATAR', avatar)
        commit('SET_INTRODUCTION', introduction)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        removeToken() // must remove  token  first
        resetRouter()
        Cookies.remove('uid')
        Cookies.remove('realname')
        commit('RESET_STATE')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
